var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 52,
    viewBox: "0 0 372 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.161331L23.8927 25.8925L0 51.5429H12.2943L29.5889 32.8294L46.9349 51.5429H59.2808L11.8819 0.161331H0Z",
    fill: "#A69D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2921 7.07136C76.6527 11.6691 74.333 17.7456 74.333 25.2472C74.333 32.7487 76.6785 39.0672 81.3436 44.0145C86.0345 48.9617 91.9368 51.4623 99.1021 51.4623H126.887V42.5357H99.1021C94.3854 42.5357 90.5192 41.0031 87.4779 37.9648C84.4365 34.8997 82.9158 30.9204 82.9158 26.0269C82.9158 21.1334 84.4365 17.0197 87.4779 13.847C90.5192 10.7011 94.4112 9.1148 99.1021 9.1148H126.887V0.161331H99.1021C91.8595 0.161331 85.9057 2.47364 81.2921 7.07136Z",
    fill: "#A69D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.657 21.1872H157.79V30.1138H186.657V51.4623H195.24V0.161331H186.657V21.1872Z",
    fill: "#A69D9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M153.872 0.161331H145.315V51.4623H153.872V0.161331Z",
    fill: "#A69D9D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M248.206 1.64012C246.866 0.537746 245.577 0 244.314 0C243.154 0 241.866 0.564633 240.422 1.72079C239.211 2.71562 238.283 3.81799 237.613 5.02792L210.885 51.4622H221.891L244.082 13.363L252.614 28.0972H239.623L234.443 37.0238H257.794L266.016 51.3816L277.073 51.4622L251.016 5.02792C250.294 3.73733 249.366 2.60807 248.206 1.64012Z",
    fill: "#A69D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M301.224 0.161331H292.667V51.4623H301.224V0.161331Z",
    fill: "#A69D9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M363.417 0.161317V35.7601L331.869 2.76938C330.194 1.02171 328.545 0.13443 326.972 0.13443C325.813 0.13443 324.936 0.564626 324.318 1.45191C323.699 2.33919 323.39 3.3609 323.39 4.57083V51.4354H331.895V15.8635L363.417 48.9348C365.402 50.9783 367.18 52 368.752 52C370.918 52 372 50.3599 372 47.0527V0.161317H363.417Z",
    fill: "#A69D9D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6818 16.5088L38.6614 22.9886L59.8478 0.161331H47.9659L32.6818 16.5088Z",
    fill: "#A69D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverLogo);
export default __webpack_public_path__ + "static/media/coverLogo.c0d5bbfcce249029b6088c2ba020ca49.svg";
export { ForwardRef as ReactComponent };